"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var AndroidPlayer = (function (_super) {
    __extends(AndroidPlayer, _super);
    function AndroidPlayer(window, commandListener) {
        var _this = _super.call(this) || this;
        _this.commandListener = commandListener;
        _this.android = window.Android;
        return _this;
    }
    AndroidPlayer.prototype.initialise = function () {
        var _this = this;
        this.registerMessageListener('state', function (data) {
            var state = parseInt(data, 10);
            _this.notifyStateChange(state);
        });
        this.registerMessageListener('error', function (data) {
            _this.raiseErrorAndStop({
                code: '',
                message: data,
                isFatal: true,
            });
        });
        this.registerMessageListener('position', function (data) {
            var parsedPosition = parseInt(data, 10);
            _this.notifyCurrentPositionChanged(parsedPosition);
        });
        this.registerMessageListener('duration', function (data) {
            var duration = parseInt(data, 10);
            _this.notifyDurationChanged(duration);
        });
        this.registerMessageListener('bitrate', function (data) {
            _this.notifyBitrateChanged({ bitrateKbps: parseInt(data, 10) });
        });
        this.registerMessageListener('availableAudioTracks', function (data) {
            var audioTracks = JSON.parse(data);
            _this.notifyAvailableAudioTracksChanged(audioTracks);
        });
        this.registerMessageListener('currentAudioTrack', function (data) {
            _this.notifyCurrentAudioTrackChanged(data);
        });
        return Promise.resolve();
    };
    AndroidPlayer.prototype.nativeLoad = function (nativeLoadData) {
        this.android.load(JSON.stringify(nativeLoadData));
    };
    AndroidPlayer.prototype.nativePlay = function () {
        this.android.play();
    };
    AndroidPlayer.prototype.nativePause = function () {
        this.android.pause();
    };
    AndroidPlayer.prototype.nativeStop = function () {
        this.android.stop();
    };
    AndroidPlayer.prototype.nativeSetVolume = function (volume) {
        return;
    };
    AndroidPlayer.prototype.nativeSetAudioTrack = function (trackId) {
        this.android.setAudioTrack(trackId);
    };
    AndroidPlayer.prototype.initiateSeek = function (seconds) {
        this.android.seek(seconds);
    };
    AndroidPlayer.prototype.setPlayoutRect = function (playoutRect) {
        this.android.setPlayoutRect(JSON.stringify(playoutRect));
    };
    AndroidPlayer.prototype.dispose = function () {
        return Promise.resolve();
    };
    AndroidPlayer.prototype.getFullScreenPlayoutRect = function () {
        return JSON.parse(this.android.getFullScreenPlayoutRect());
    };
    AndroidPlayer.prototype.registerMessageListener = function (command, callback) {
        this.commandListener.registerMessageListener(command, callback);
    };
    return AndroidPlayer;
}(client_lib_js_player_addons_common_player_1.Player));
exports.AndroidPlayer = AndroidPlayer;
